import Vue from "vue";
import Vuex from "vuex";
import eventModule from "./planning/eventStore";
import notificationModule from "./planning/notification";
import locationModule from "./planning/locationStore";
import courseModule from "./planning/courseStore";
import userModule from "./planning/userStore";
import websocketModule from "./planning/websocketStore";
import leavePeriodModule from "./planning/leavePeriodStore";
import freeDaysModule from "./planning/freeDaysStore";
import taskModule from "./planning/taskStore";
import interventionFollowedModule from "./planning/interventionFollowedStore";
import centerModule from "./salles/centerStore";
import roomModule from "./salles/roomStore";
import equipmentModule from "./salles/equipmentStore";
import deskModule from "./salles/deskStore";
import categorieModule from "./salles/categoryStore";
import deskSlotModule from "./salles/deskSlotStore";
import bookingModule from "./salles/bookingStore";
import subscriptionModule from "./salles/subscriptionStore";

// register chart components
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    namespaced: true,
    notificationModule,
    locationModule,
    courseModule,
    userModule,
    eventModule,
    websocketModule,
    leavePeriodModule,
    freeDaysModule,
    taskModule,
    interventionFollowedModule,
    centerModule,
    roomModule,
    equipmentModule,
    deskModule,
    categorieModule,
    deskSlotModule,
    bookingModule,
    subscriptionModule,
  },
});

export default store;
